import { Select, SelectProps } from 'antd';
import { NBSOptions } from './options';
import { useState } from 'react';

export default function InvoiceNBSSelect(props: Omit<SelectProps, 'options'>) {
  const [search, setSearch] = useState('');

  const options = NBSOptions.filter(
    (option) =>
      option.value.replaceAll('.', '').includes(search) ||
      option.value.includes(search) ||
      option.label.toLowerCase().includes(search.toLowerCase()),
  ).map((option) => ({
    value: option.value.replace('.', ''),
    label: `${option.value} - ${option.label}`,
  }));

  return (
    <Select
      {...props}
      options={options}
      showSearch
      onSearch={setSearch}
      searchValue={search}
      filterOption={false}
    />
  );
}
